export const defaultEntity = 'erogatori';
export const entities = ['erogatori'];
export const labels = {
    erogatori: 'Erogatori',
    servizi: 'Servizi',
    prestazioni: 'Prestazioni',
    struttureSanitarie: 'Strutture sanitarie',
};